import React from 'react';

import './button-secondary.scss';

interface ButtonSecondaryProps {
  children: React.ReactNode;
  className?: string;
  [x: string]: unknown;
}

export default function ButtonSecondary({
  children,
  className = '',
  ...props
}: ButtonSecondaryProps) {
  return (
    <div className="button-secondary">
      <button
        {...props}
        className={`button-text button is-fullwidth content-normal ${className ? className : ''}`}
      >
        {children}
      </button>
    </div>
  );
}
